export default function CustomerAddPointsController(
  $state,
  $stateParams,
  $filter,
  customersService,
  UtilService,
  NotificationService,
  notificationHelper,
  POINT_TYPES,
) {
  var vm = this;

  vm.isLoading = false;
  vm.customerId = $stateParams.customerId;
  vm.customer = $stateParams.customer;
  vm.allPointTypes = POINT_TYPES;

  vm.pointsParams = {
    referenceId: null,
    type: null,
    reason: null,
    amount: null,
  };
  vm.campaignName = null;
  vm.campaignPoints = null;
  vm.reservationId = null;
  vm.reviewId = null;

  vm.options = {
    pointsType: [
      {
        id: POINT_TYPES.RESERVATION,
        name: 'Reservation Points',
      },
      {
        id: POINT_TYPES.REVIEW,
        name: 'Review Points',
      },
      {
        id: POINT_TYPES.REFERRAL,
        name: 'Refer a friend Points',
      },
      {
        id: POINT_TYPES.APOLOGY,
        name: 'Apology Points',
      },
      {
        id: POINT_TYPES.DEDUCT,
        name: 'Deduct Points',
      },
    ],
    apologyPoints: [25, 100, 200, 300, 400, 500],
    deductPoints: [-1000, -5000, -10000],
    reservations: [],
    reviews: [],
    referrals: [],
  };

  vm.init = init;
  vm.addPoints = addPoints;
  vm.updateCampaign = updateCampaign;
  vm.resetCampaign = resetCampaign;

  init();

  function init() {
    getReservations();
    getReviews();
    getReferrals();
  }

  function getReservations() {
    enableLoading();
    customersService
      .getCustomerReservations(vm.customerId)
      .then(initReservations)
      .finally(disableLoading);
  }

  function initReservations(res) {
    if (res && res.data) {
      vm.options.reservations = res.data.reservations.filter(function(reservation) {
        return reservation.bestCampaign && !reservation.accountTransferStatus;
      });
    }
  }

  function getReviews() {
    enableLoading();
    customersService
      .getPublishedReviews(vm.customerId)
      .then(initReviews)
      .finally(disableLoading);
  }

  function initReviews(res) {
    if (res && res.data) {
      vm.options.reviews = res.data
        .filter(function(review) {
          return review.bestCampaign && !review.accountTransferStatus;
        })
        .map(function(review) {
          var date = $filter('date')(review.createdAt, 'dd.MM.yyyy'),
            rating = ' - Rating ' + review.rating + '/6 - ';
          review.label = date + rating + review.merchant.name;
          return review;
        });
    }
  }

  function getReferrals() {
    enableLoading();
    customersService
      .getCustomerReferrals(vm.customerId)
      .then(initReferrals)
      .finally(disableLoading);
  }

  function initReferrals(res) {
    if (res && res.data) {
      vm.options.referrals = res.data
        .filter(function(referralReservation) {
          return referralReservation.bestCampaign && !referralReservation.accountTransferStatus;
        })
        .map(function(referralReservation) {
          referralReservation.label = referralReservation.referral.email + ' (Reservation ' + referralReservation.id + ')';
          return referralReservation;
        });
    }
  }

  function updateCampaign(id, items) {
    var item = UtilService.findElementById(items, id);
    if (item && item !== -1 && item.bestCampaign) {
      vm.pointsParams.referenceId = item.id;
      vm.campaignName = item.bestCampaign.campaign.name;
      vm.campaignPoints = item.bestCampaign.points;
    }
  }

  function resetCampaign() {
    vm.pointsParams.referenceId = null;
    vm.campaignName = null;
    vm.campaignPoints = null;
    vm.reservationId = null;
    vm.reviewId = null;
  }

  function addPoints() {
    if (vm.isLoading) {
      return;
    }
    enableLoading();

    if (vm.pointsParams.amount < 0) {
      delete vm.pointsParams.referenceId;
      customersService
        .deductCustomerPoints(vm.customerId, vm.pointsParams)
        .then(function() {
          $state.go(
            'app.customers.edit',
            {
              customerId: vm.customerId,
              tab: 'points',
            },
            { reload: true },
          );
        })
        .then(function() {
          NotificationService.success('Points successfully deducted');
        })
        .catch(function(res) {
          notificationHelper.showError(res, 'Error removing points');
        })
        .finally(disableLoading);
      return;
    }

    customersService
      .addCustomerPoints(vm.customerId, vm.pointsParams)
      .then(function() {
        $state.go(
          'app.customers.edit',
          {
            customerId: vm.customerId,
            tab: 'points',
          },
          { reload: true },
        );
      })
      .then(function() {
        NotificationService.success('Points successfully added');
      })
      .catch(function(res) {
        notificationHelper.showError(res, 'Error adding points');
      })
      .finally(disableLoading);
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/points/add-points.controller.js